<template>
  <div class="pagination-block flex">
    <a href="#" class="page-btn flex" @click.prevent="changePage(1)">الصفحة الأولي</a>
    <ul class="pagination">
      <li class="page-item" :class="{disabled: current === 1}">
        <a class="page-link next" href="#" @click.prevent="changePage(current - 1)">
          <i class="fas fa-angle-double-right"></i>
        </a>
      </li>
      <li
        class="page-item"
        v-for="page in total"
        :key="page"
        :class="{active: page === current}"
      >
        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
      </li>
      <li class="page-item" :class="{disabled: current === total}">
        <a class="page-link previous" href="#" @click.prevent="changePage(current + 1)">
          <i class="fas fa-angle-double-left"></i>
        </a>
      </li>
    </ul>
    <a href="#" class="page-btn flex" @click.prevent="changePage(total)">الصفحة الأخيرة</a>
  </div>
</template>

<script>
export default {
  name: 'PaginationTeacher',
  props: {
    current: { type: Number, required: true },
    total: { type: Number, required: true }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.total || page === this.current) return;
      this.$emit('page-change', page);
    }
  }
}
</script>

<style scoped>
.pagination-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 1rem;
}
.page-btn {
  margin: 0 10px;
}
</style>
